import * as React from 'react'; 


export interface BurgerIconProps{
    className?:string;
    onClick:() => void;
}

export const BurgerIcon: React.SFC<BurgerIconProps> = (props) => {
    let cls = props.className || "";

    return (
        <div className={"burger-icon " + cls}
             onClick={props.onClick}
             ref={e => this.el = e}
        >
            <span className="burger-icon__block"></span>
            <span className="burger-icon__block"></span>
            <span className="burger-icon__block"></span>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/ui/BurgerIcon/BurgerIcon.tsx